export default __webpack_public_path__ + "static/media/FAQ_9_1.fd9ce16b.png";